
import * as THREE from 'three';

export class VectorUtility {

    // y軸基準での回転角を求める
    public static rotaion(object: THREE.Object3D) {
        // Y軸基準での回転角
        // X-Z平面に射影を行いZ(0,0,1)との角度を測る
        const zvector = new THREE.Vector3(0, 0, 1);
        const vec3 = object.getWorldDirection(new THREE.Vector3());
        let angle = zvector.angleTo(vec3);

        const xVEc = new THREE.Vector3(1, 0, 0);
        if (xVEc.dot(vec3) < 0) angle *= -1;
        return angle;
    }
    
}